import { Outlet } from 'react-router-dom';
import { SessionAuth } from 'supertokens-auth-react/recipe/session';
import LogoFull from '../../assets/images/logo/logo-full.svg?react';
import { useIsMobile } from '../../hooks/useIsMobile';
import SlackCallbackNotice from '../../components/SlackCallbackNotice/SlackCallbackNotice';

import './BaseAuthLayout.scss';

export default function BaseAuthLayout(): JSX.Element {
  const isMobile = useIsMobile();

  return (
    <SessionAuth>
      {/* Renders nothing; reports the Slack link callback's outcome wherever it lands. */}
      <SlackCallbackNotice />
      {isMobile ? <MobileComponent /> : <Outlet />}
    </SessionAuth>
  );
}

const MobileComponent = () => {
  return (
    <div className="mobile-auth-notice w-screen h-screen bg-gray-100 flex items-center justify-center">
      <div className="w-80 h-48 flex flex-col items-center space-y-6">
        <div className="text-center text-zinc-800 text-[32px] font-semibold font-['Figtree']">Welcome to</div>
        <LogoFull role="img" aria-label="Logo" className="h-6 w-auto" />
        <div className="text-center text-zinc-800 text-base font-normal font-['Figtree']">
          For the best experience, log in to
          <br />
          Taskonio from the desktop.
        </div>
      </div>
    </div>
  );
};
